import {BETACATEGORY, BETADETAIL, BETALIST} from 'src/redux/actions/actionTypes';

let betaData = [];

export const mainBetaReducer = (state = betaData, action) => {
  switch (action.type) {
    case BETALIST:
    case BETADETAIL:
    case BETACATEGORY:
      /* Login success */
      betaData.splice(0, betaData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        betaData.push(action.payload.data.res);
        return betaData;
      }
      return betaData;
    default:
      return state;
  }
};
